import { IEmployeeBoxProps } from '../../employee-box/employee-box';
import { ICheckboxProps } from '../components/checkbox/checkbox';
import { IGroupedCheckboxesProps } from '../components/groupedCheckboxes/groupedCheckboxes';
import { IInputProps } from '../components/input/input';

export interface IFormComponentProps {
  contactButtonCta: string;
  formClassName: string;
  inputs: IInputProps[];
  checkboxes: ICheckboxProps[];
  groupedCheckboxes?: IGroupedCheckboxesProps[];
  contactPerson: IEmployeeBoxProps | null;
  postUrl?: string;
  privacyPolicyAgreement: string;
  successMessage?: string;
  userCountry?: string;
  clientIp?: string;
  campaignId?: string;
  webinarTag?: string;
  useReCAPTCHA?: boolean;
}

export type ContactFormState = {
  checkIsValid: boolean;
  isError: boolean;
  formSend: boolean;
  formFields?: Field;
  groupedCheckboxesFields?: GroupField;
  groupedCheckboxesErrors?: Error;
  isTouched: boolean;
};

export type ContactFormAction = {
  type: ContactFormActionType;
  payload?: {
    fieldName?: string;
    fieldValue?: string | number | boolean;
    fields?: Field;
    errors?: Error;
    groupName?: string;
    groupedCheckboxesFields?: GroupField;
    groupedFieldValue?: string;
    initialFieldValues?: Field;
    initialGroupedFieldValues?: GroupField;
  };
};

export type Error = {
  [s: string]: boolean;
};

export type GroupField = {
  [s: string]: string[];
};

export type Field = {
  [s: string]: string | boolean | number;
};

export enum ContactFormActionType {
  CHECK_VALIDITY,
  RESET_FORM,
  SUCCESS_MESSAGE,
  ERROR,
  REMOVE_MESSAGE,
  FORM_VALUE_CHANGE,
  GROUP_VALUE_CHANGE,
  SET_FIELDS,
  SET_IS_TOUCHED,
  SET_GROUPED_ERRORS,
  UPDATE_GROUPED_ERRORS
}
